import {useEffect, useRef, useState} from "react";
import store from "../../../reducers/createReducers";
import associateServices from "../../../services";
import SESSION_HELPER from "../../../helpers/session-helper";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import './index.css'
import FormButton from "../../../components/form-button";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useLocation} from "react-router-dom";
import StringHelper from "../../../helpers/string-helper";
import InputMask from "react-input-mask";
import SvgIcon from "../../../components/svg-icon";
import {useSelector} from "react-redux";
import InformationToast from "../../../components/toast/InformationToast";
import RegisterSocialAuth from "./social-auths";
import {LazyLoadImage} from "react-lazy-load-image-component";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import tr from 'react-phone-input-2/lang/tr.json'
import stringHelper from "../../../helpers/string-helper";
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = '6LclC10rAAAAAPrQoCwwhw-2oku8DJwYR6FDqSqv';

const types = ['public', 'secret'];

const fpPromise = FingerprintJS.load()

const Register = props => {

    const recaptchaRef = useRef();

    const handleSubmit = async (e) => {
        // e.preventDefault();
        const token = await recaptchaRef?.current?.executeAsync();
        recaptchaRef.current.reset();

        // Send token to backend for verification
        console.log("reCAPTCHA token:", token);
    };


    // const recaptcha = useRef()
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {activeLanguage, theme, configuration} = useSelector(state => state.globalReducer)

    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const {handleClose, handleModalAction} = props

    const maskRef = useRef(null)
    const location = useLocation()
    const [errors, setErrors] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const [step, setStep] = useState('form')
    const [showActiveType, setShowActiveType] = useState(false)
    const [activeType, setActiveType] = useState('secret')

    useEffect(() => {
        if (step !== 'form' && maskRef?.current)
            maskRef?.current?.focus()
    }, [step, maskRef])

    const [secret, setSecret] = useState('')
    const [otp, setOtp] = useState('')
    const [sms, setSms] = useState('')
    const [settings, setSettings] = useState(null)
    const [image, setImage] = useState(null)
    const [instance, setInstance] = useState({
        username: '',
        email: '',
        password: '',
        birthday: '',
        ref: '',
        checked: false,
    })

    useEffect(() => {

        if (configuration?.country) {

            if (settings?.force_public_registrations?.includes(configuration?.country)) {
                setActiveType('public')
                setShowActiveType(false)
            } else if (settings?.default_public_registrations?.includes(configuration?.country)) {
                setActiveType('public')
                setShowActiveType(true)
            } else
                setShowActiveType(true)

        }
    }, [settings, configuration])

    useEffect(() => {
        let ref = '';
        const localRef = localStorage.getItem('refcode')
        if (localRef)
            ref = localRef

        setInstance(activeType === 'public' ? {
            username: '',
            email: '',
            password: '',
            birthday: '',
            name: '',
            surname: '',
            identity_no: '',
            ref: ref,
            checked: false,
        } : {
            username: '',
            email: '',
            password: '',
            birthday: '',
            ref: ref,
            checked: false,
        })
    }, [activeType])

    const [showPass, setShowPass] = useState(false)
    const [refDisabled, setRefDisabled] = useState(false)

    const [code, setCode] = useState('')
    const [countries, setCountries] = useState([])
    const searchParams = new URLSearchParams(location?.search);

    useEffect(() => {
        associateServices.getCountryList({}).then(res => setCountries(res?.data || []))


    }, [])


    useEffect(() => {
        if (!authenticated) {
            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('signup-modal')
            if (mdl) {
                mdl.classList?.add('show')

                mdl.style.display = 'block'
                mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

                mdl.classList?.add('modal-fade')
            }

            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }
    }, [authenticated])


    useEffect(() => {
        const getParams = (key) => {
            const searchParams = new URLSearchParams(location?.search);
            return searchParams.get(key);
        }
        const ref = getParams('ref')
        if (ref) {
            associateServices.clickCampaign({
                secret: ref
            }).then(null)

            handleChange('ref', ref)
            localStorage.setItem('refcode', ref)

            setRefDisabled(true)
        }
    }, [location?.search])

    useEffect(() => {
        associateServices.getAuthSettings({
            model: 'register',
            language: activeLanguage?.key,
            theme
        }).then(res => {
            if (res?.data?.image?.image) {
                setImage(res?.data?.image?.image)

                const mdl = document.getElementById('signup-modal')

                if (mdl)
                    mdl.classList?.add('modal--sign')
            }


            setSettings(res?.data?.settings)
        })
    }, [activeLanguage?.key, theme])

    const handleChange = (type, value) => {
        setErrors({})
        setInstance(prevState => ({
            ...prevState,
            [type]: value
        }))
    }

    // stringHelper.getLocalizedPath(currentLanguage, `/policy`)
    const handlePolicy = () => window.open(stringHelper.getLocalizedPath(currentLanguage, `/policy`), '_blank')
    const handleRegister = async (e) => {



        if (submitting)
            return false;

        setErrors({})
        Object.keys(instance).forEach(function (key, index) {
            if (key === 'email' && !settings?.email_required)
                return setErrors(prevState => prevState)

            if (!instance[key] && key !== 'ref')
                return setErrors(prevState => ({
                    ...prevState,
                    [key]: 'form-field-cant-be-null'
                }))
        });

        if (settings?.sms_required) {
            if (!phone?.country_id || !phone?.number)
                return setErrors(prevState => ({
                    ...prevState,
                    phone: 'form-field-cant-be-null'
                }))
        }

        const [day, month, year] = instance?.birthday.split("-");

        const isValidDate = validateDate(day, month, year)
        if (!isValidDate)
            return setErrors(prevState => ({
                ...prevState,
                birthday: 'enter-a-valid-birthday'
            }))

        if (Object.keys(errors)?.length >= 1)
            return false

        if (!instance.checked)
            return setErrors(prevState => ({
                ...prevState,
                checked: 'you-must-check-agreement'
            }))

        setSubmitting(true)

        let ref = instance.ref

        if (!ref) {
            const localRef = localStorage.getItem('refcode')
            if (localRef)
                ref = localRef
        }

        const fp = await fpPromise
        const result = await fp.get()

        const visitorId = result.visitorId

        // const token = await recaptchaRef.current.executeAsync();
        // recaptchaRef.current.reset();

        // console.log("reCAPTCHA token:", token);


        associateServices.register({
            ...instance,
            ...phone,
            agent: SESSION_HELPER.getUserAgent(),
            otp,
            secret,
            ref,
            visitorId,
            sms,
            type: activeType,
            // recaptcha: token
        })
            .then(handleRegisterResponse)


    }
    const handleRegisterResponse = response => {

        if (response?.status !== 200 || response?.errors) {
            // toast.error(t(`api-notifications.${response?.errors}`))
            toast(<InformationToast
                icon={'ti-error-404'}
                title={t('general.information')}
                message={t(`api-notifications.${response?.errors}`)}
            />)
            return setSubmitting(false)
        }

        if (response?.data?.step === 'email') {
            setStep(response?.data?.step)
            setSubmitting(false)
            return setSecret(response?.data?.secret)

        }


        store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
        handleClose()
        // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
        return setSubmitting(false)
    }

    const handleChangeBirthday = (value) => {
        // Validation after input

        handleChange('birthday', value)
        if (value.length === 10) {
            const [day, month, year] = value.split("-");

            // Convert to integers
            const dayInt = parseInt(day, 10);
            const monthInt = parseInt(month, 10);
            const yearInt = parseInt(year, 10);


            if (dayInt && dayInt?.toString()?.length === 2 && monthInt && monthInt?.toString()?.length === 2 && yearInt && yearInt?.toString()?.length === 4) {
                // Check for logical errors
                const isValidDate = validateDate(dayInt, monthInt, yearInt);

                if (isValidDate) {
                    setErrors(prevState => ({
                        ...prevState,
                        birthday: ''
                    }))
                } else {
                    setErrors(prevState => ({
                        ...prevState,
                        birthday: 'enter-a-valid-birthday'
                    }))
                }

            }

        }
    };

    const validateDate = (day, month, year) => {
        // Simple checks
        if (month < 1 || month > 12) return false;
        if (day < 1 || day > 31) return false;

        // Check month-specific days (February and leap years)
        const daysInMonth = new Date(year, month, 0).getDate();
        return day <= daysInMonth;
    };

    const handleKeyDown = (event) => {

        if (event.key === 'Enter')
            if (step === 'form') {
                handleRegister()
            } else {
                if (otp?.length === 6)
                    handleRegister()
            }
    }
    const handleHide = () => {
        setShowPass(prevState => !prevState)
    }

    const handleChangePhone = (phone, country) => {
        setCode(phone)
        setDefaultCountry(country?.countryCode)
    }
    const [defaultCountry, setDefaultCountry] = useState('tr')

    useEffect(() => {
        console.log('configuration?.country = ,', configuration?.country)
        setDefaultCountry(configuration?.country?.toLowerCase())
    }, [configuration?.country])

    const [phone, setPhone] = useState({
        country_id: '',
        number: '',
    })

    useEffect(() => {

        const item = countries?.find(pp => pp?.iso2?.toUpperCase() === defaultCountry?.toUpperCase())
        let num = code?.replace(item?.phone_code, ''); // Replace '90' with an empty string

        console.log('item = ', item)

        setPhone({
            country_id: item?.id,
            number: num,
            phone_code: item?.phone_code,

        })
    }, [code, defaultCountry])
    return (
        <div
            className={`modal fade`}
            id="signup-modal"
            tabIndex={-1}
            aria-labelledby="signup-modal"
            aria-hidden="true"
            // onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal__content">

                        {
                            image &&
                            <div className="modal__sign-img">
                                {/*<img*/}
                                {/*    src={image}*/}
                                {/*    alt="png"/>*/}


                                <LazyLoadImage
                                    height={'100%'}
                                    width={'100%'}
                                    effect="blur"
                                    src={image}
                                    placeholderSrc={image}
                                    alt=""/>


                                {/*<Loading/>*/}
                            </div>
                        }

                        <div className="modal__head">

                            <h6 className="modal__title">
                                {t('register.signup')}
                            </h6>
                            {
                                showActiveType &&
                                <ul
                                    className="nav nav-tabs tabs-nav"
                                    id="tabs-nav"
                                    role="tablist"
                                >

                                    {
                                        types?.map(type => (
                                            <li className="nav-item" role="presentation" key={type}>
                                                <button
                                                    onClick={e => setActiveType(type)}
                                                    className={`tabs-nav__btn ${activeType === type ? 'active' : ''} tabs-nav__btn__small`}
                                                    type="button">
                                                    {t(`general.registration.${type}`, type)}
                                                </button>
                                            </li>
                                        ))
                                    }

                                </ul>
                            }
                            <button
                                className="modal__close"
                                type="button" onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>

                        {
                            step === 'form' ?


                                <div className="modal__form">
                                    <div className="settings__form">
                                        <div className="row">
                                            <div
                                                className={settings?.email_required || settings?.email_optional ? 'col-6 col-xl-6 col-xxl-6' : 'col-12 col-xl-12 col-xxl-12'}>
                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t('register.username')}
                                                        <b>*</b>
                                                    </label>
                                                    <input
                                                        value={instance?.username}
                                                        maxLength={16}
                                                        onChange={e => handleChange('username', StringHelper.getStringEN(e.target.value?.replace(/[^a-zA-Z0-9\u0400-\u04FF\s]/gi, '')?.replace(/\s/g, '')))}
                                                        type="text" className="form__input"/>

                                                    {
                                                        errors?.username &&
                                                        <p className="form__note error">
                                                            * {t(`general.${errors?.username}`)}
                                                        </p>
                                                    }
                                                </div>
                                            </div>

                                            {
                                                (settings?.email_required || settings?.email_optional) &&
                                                <div className="col-6 col-xl-6 col-xxl-6">
                                                    <div className="form__group">
                                                        <label htmlFor="" className="form__label">
                                                            {t('register.email')}
                                                            <b>*</b>
                                                        </label>
                                                        <input
                                                            value={instance?.email}
                                                            onChange={e => handleChange('email', StringHelper.getStringEN(e.target.value?.replace(/\s/g, '')))}
                                                            type="text" className="form__input"/>
                                                        {
                                                            errors?.email &&
                                                            <p className="form__note error">
                                                                * {t(`general.${errors?.email}`)}
                                                            </p>
                                                        }
                                                    </div>
                                                </div>

                                            }
                                        </div>
                                    </div>


                                    <div className="form__group form__group--pass1">
                                        <label htmlFor="" className="form__label">
                                            {t('register.password')}
                                            <b>*</b>
                                        </label>

                                        <input
                                            onKeyDown={handleKeyDown}
                                            autoComplete={'current-password'}
                                            value={instance?.password}
                                            onChange={e => handleChange('password', e.target.value)}
                                            type={showPass ? 'text' : 'password'}
                                            className="form__input" id="pass1"/>

                                        <button
                                            onClick={handleHide}
                                            className="form__pass" type="button" id="togglePass1">
                                            <SvgIcon id={showPass ? 'eye-hidden' : 'eye-show'}/>
                                        </button>

                                    </div>
                                    {
                                        errors?.password &&
                                        <p className="form__note error">
                                            * {t(`general.${errors?.password}`)}
                                        </p>
                                    }

                                    {
                                        activeType === 'public' ?
                                            <>
                                                <div className="settings__form">
                                                    <div className="row">
                                                        <div className="col-6 col-xl-6 col-xxl-6">
                                                            <div className="form__group">
                                                                <label htmlFor="" className="form__label">
                                                                    {t('general.registration.name', 'Name')}
                                                                    <b>*</b>
                                                                </label>
                                                                <input
                                                                    value={instance?.name}
                                                                    maxLength={16}
                                                                    onChange={e => handleChange('name', e.target.value)}
                                                                    type="text" className="form__input"/>

                                                                {
                                                                    errors?.name &&
                                                                    <p className="form__note error">
                                                                        * {t(`general.${errors?.name}`)}
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-xl-6 col-xxl-6">
                                                            <div className="form__group">
                                                                <label htmlFor="" className="form__label">
                                                                    {t('general.registration.surname', 'Surname')}
                                                                    <b>*</b>
                                                                </label>
                                                                <input
                                                                    value={instance?.surname}
                                                                    onChange={e => handleChange('surname', e.target.value)}
                                                                    type="text" className="form__input"/>
                                                                {
                                                                    errors?.surname &&
                                                                    <p className="form__note error">
                                                                        * {t(`general.${errors?.surname}`)}
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="settings__form">
                                                    <div className="row">
                                                        <div className="col-6 col-xl-6 col-xxl-6">
                                                            <div className="form__group">
                                                                <label htmlFor="" className="form__label">
                                                                    {t('general.registration.identity_no', 'Identity NO')}
                                                                    <b>*</b>
                                                                </label>
                                                                <input
                                                                    value={instance?.identity_no}
                                                                    maxLength={16}
                                                                    onChange={e => handleChange('identity_no', e.target.value)}
                                                                    type="text" className="form__input"/>

                                                                {
                                                                    errors?.identity_no &&
                                                                    <p className="form__note error">
                                                                        * {t(`general.${errors?.identity_no}`)}
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>

                                                        {
                                                            (settings?.sms_required || settings?.sms_optional) &&
                                                            <>
                                                                <div className="col-6 col-xl-6 col-xxl-6">
                                                                    <div className="form__group">
                                                                        <label htmlFor="" className="form__label">
                                                                            {t('settings.general.phone-number')}<b>*</b>
                                                                        </label>


                                                                        <PhoneInput
                                                                            searchPlaceholder={t('general.search')}
                                                                            inputClass={'form__input'}
                                                                            country={defaultCountry}
                                                                            localization={configuration?.country?.toUpperCase() === 'CY' && tr}
                                                                            enableSearch={true}
                                                                            value={code}
                                                                            onChange={handleChangePhone}
                                                                        />

                                                                        {
                                                                            errors?.phone &&
                                                                            <p className="form__note error">
                                                                                * {t(`general.${errors?.phone}`)}
                                                                            </p>
                                                                        }
                                                                    </div>

                                                                </div>

                                                            </>

                                                        }
                                                    </div>
                                                </div>
                                            </>

                                            :

                                            (settings?.sms_required || settings?.sms_optional) &&
                                            <div className="settings__form">
                                                <div className="row">
                                                    <div className="col-12 col-xl-12 col-xxl-12">
                                                        <div className="form__group">
                                                            <label htmlFor="" className="form__label">
                                                                {t('settings.general.phone-number')}<b>*</b>
                                                            </label>

                                                            <PhoneInput
                                                                searchPlaceholder={t('general.search')}
                                                                inputClass={'form__input'}
                                                                country={defaultCountry}
                                                                localization={configuration?.country?.toUpperCase() === 'CY' && tr}
                                                                enableSearch={true}
                                                                value={code}
                                                                onChange={handleChangePhone}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                {
                                                    errors?.phone &&
                                                    <p className="form__note error">
                                                        * {t(`general.${errors?.phone}`)}
                                                    </p>
                                                }
                                            </div>
                                    }


                                    <div className="settings__form">

                                        <div className="row">
                                            <div className="col-6 col-xl-6 col-xxl-6">

                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t('register.birthday')}
                                                        <b>*</b>
                                                    </label>

                                                    <InputMask mask="99-99-9999"
                                                               className="form__input"
                                                               value={instance?.birthday || ''}
                                                               pattern="[0-9]*"
                                                               inputMode="numeric"
                                                               onChange={e => handleChangeBirthday(e.target.value)}
                                                    />


                                                    {
                                                        errors?.birthday &&
                                                        <p className="form__note error">
                                                            * {t(`general.${errors?.birthday}`)}
                                                        </p>
                                                    }

                                                </div>
                                            </div>

                                            <div className="col-6 col-xl-6 col-xxl-6">
                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t('register.ref_code')}
                                                        <b>*</b>
                                                    </label>
                                                    <input
                                                        disabled={refDisabled}
                                                        value={instance?.ref}
                                                        onChange={e => handleChange('ref', e.target.value)}
                                                        type="text" className="form__input"/>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="form__checkbox"
                                         onClick={value => handleChange('checked', !instance.checked)}
                                    >
                                        <input
                                            checked={instance.checked} disabled type="checkbox"
                                            name={t('register.agreement')}/>

                                        <label htmlFor={t('register.agreement')}>
                                            {/*<span className="check-wrapper">*/}
                                            {/*    {*/}
                                            {/*        instance?.checked &&*/}
                                            {/*        <SvgIcon id={'checked'}/>*/}
                                            {/*    }*/}
                                            {/*</span>*/}
                                            {t('register.agreement')}
                                        </label>

                                        <button
                                            onClick={handlePolicy}
                                            type="button" className="m-lg-2">
                                            <SvgIcon extra={'mini-icon'} id={'link'}/>

                                        </button>

                                    </div>


                                    {
                                        errors?.checked &&
                                        <p className="form__note error">
                                            * {t(`general.${errors?.checked}`)}
                                        </p>
                                    }


                                    {/*<div className="col-12 d-flex justify-content-center align-items-center">*/}
                                    {/*    <ReCAPTCHA hl={activeLanguage?.key || 'en'} ref={recaptcha}*/}
                                    {/*               theme={theme}*/}
                                    {/*               sitekey={process.env.REACT_APP_SITE_KEY}/>*/}
                                    {/*</div>*/}


                                    {/*<ReCAPTCHA*/}
                                    {/*    sitekey={RECAPTCHA_SITE_KEY}*/}
                                    {/*    size="invisible"*/}
                                    {/*    ref={recaptchaRef}*/}
                                    {/*    onErrored={() => console.log('reCAPTCHA errored')}*/}
                                    {/*    onExpired={() => console.log('reCAPTCHA expired')}*/}
                                    {/*    onChange={(token) => console.log('reCAPTCHA success:', token)}*/}
                                    {/*/>*/}

                                    <FormButton
                                        disabled={submitting}
                                        // disabled={true}
                                        loading={submitting}
                                        onClick={handleRegister}
                                        // onClick={null}
                                        label={t('modals.login.sign-up')}
                                    />
                                    {/*<p className="form__note error align-self-center">*/}
                                    {/*    * Registration is disabled till test V3 completed. We will announce when V3 completed.*/}
                                    {/*</p>*/}


                                    <span className="form__delimiter">
                                      <span>
                                            {t('register.or')}
                                      </span>
                                    </span>


                                    {
                                        settings?.id &&

                                        <RegisterSocialAuth loading={submitting} handleClose={handleClose}
                                                            settings={settings}
                                                            setLoading={setSubmitting}/>

                                    }


                                    <div className="form__text">
                                        <p>
                                            {t('register.have-account')}
                                            {" "}
                                            <button
                                                type="button"
                                                // onClick={e => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('login'))}
                                                onClick={e => handleModalAction('login')}

                                            >

                                                {t('register.signin')}
                                            </button>
                                        </p>
                                    </div>
                                </div>

                                :
                                <div className="modal__form">

                                    {
                                        settings?.email_required ?
                                            <>
                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t('register.email')}
                                                        <b>*</b>
                                                    </label>
                                                    <input
                                                        disabled
                                                        value={instance?.email}
                                                        type="text" className="form__input"/>
                                                </div>

                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t(`general.enter-otp-code-${step}`)} <b>*</b>
                                                    </label>
                                                    <InputMask
                                                        onKeyDown={handleKeyDown}
                                                        mask={'999999'}
                                                        maskPlaceholder={null}
                                                        disabled={step === 'form'}
                                                        className="form__input"
                                                        value={otp}
                                                        onChange={e => setOtp(e.target.value)}
                                                        ref={maskRef}

                                                        type="text" // Set type to text
                                                        inputMode="numeric" // Hint for numeric keyboard
                                                    />
                                                </div>

                                            </>
                                            :
                                            null
                                    }
                                    {
                                        settings?.sms_required ?
                                            <>
                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t('settings.general.phone-number')}
                                                        <b>*</b>
                                                    </label>

                                                    <PhoneInput
                                                        searchPlaceholder={t('general.search')}
                                                        inputClass={'form__input'}
                                                        country={defaultCountry}
                                                        localization={configuration?.country?.toUpperCase() === 'CY' && tr}
                                                        enableSearch={true}
                                                        value={code}
                                                        disabled
                                                    />
                                                </div>
                                                <div className="form__group">
                                                    <label htmlFor="" className="form__label">
                                                        {t(`general.enter-otp-code-phone`)} <b>*</b>
                                                    </label>
                                                    <InputMask
                                                        onKeyDown={handleKeyDown}
                                                        mask={'999999'}
                                                        maskPlaceholder={null}
                                                        disabled={step === 'form'}
                                                        className="form__input"
                                                        value={sms}
                                                        onChange={e => setSms(e.target.value)}

                                                        type="text" // Set type to text
                                                        inputMode="numeric" // Hint for numeric keyboard
                                                    />
                                                </div>
                                            </>
                                            :
                                            null
                                    }


                                    {/*<ReCAPTCHA*/}
                                    {/*    sitekey={RECAPTCHA_SITE_KEY}*/}
                                    {/*    size="invisible"*/}
                                    {/*    ref={recaptchaRef}*/}
                                    {/*    onErrored={() => console.log('reCAPTCHA errored')}*/}
                                    {/*    onExpired={() => console.log('reCAPTCHA expired')}*/}
                                    {/*    onChange={(token) => console.log('reCAPTCHA success:', token)}*/}
                                    {/*/>*/}

                                    <FormButton
                                        disabled={submitting}
                                        loading={submitting}
                                        onClick={handleRegister}
                                        label={t('modals.login.sign-up')}
                                    />

                                </div>

                        }

                    </div>
                </div>
            </div>


        </div>


    )

}

export default Register;

